
import { i18nManager } from "../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import Notifications from "../../shared/Notifications";
import { NotificationGroup } from "../../shared/Notifiier";
import { ApiResponseData, BaseService, INotification, MemberNotificationService, SanitizedResponse, TeamService } from "../../../services";
import { ConfirmDialog, Siren } from "../../shared/ConfirmDialog";
import { AlertInterface, useSubscription } from "@rivtn/noseur";

function TeamNotifications() {

    const labels = i18nManager.Labels.teams;
    let { id } = ReactRouterDom.useParams();
    let { state } = ReactRouterDom.useLocation();
    const teamService = TeamService.getInstance();
    useSubscription("TEAM.CANCEL_TEAM", cancelTeamInvite);
    const [searchParams, _] = ReactRouterDom.useSearchParams(window.location.search);

    return (<Notifications
        canGoBack
        service={teamService}
        subTitle={state?.teamName}
        title={labels.title + " - " + id + " - " + i18nManager.Labels.compound.top_navbar.popover.notification.notifications}
        markAllAsRead={(done, success) => {
            teamService.markAllAsRead(id!).then(({ }: SanitizedResponse<void>) => {
                Siren.alert(i18nManager.Labels.compound.top_navbar.popover.notification.mark_all_read_success);
                success();
            }).catch(BaseService.reportError).finally(done);
        }}
        fetch={(section, done, success) => {
            teamService.queryNotifications({
                "team.public_id": id,
                page: parseInt(searchParams.get("page") ?? "1"),
                size: parseInt(searchParams.get("size") ?? "50"),
                status: (section === "unread" ? "UN_READ" : undefined),
            }).then(({ sanitized, apiResponse }: SanitizedResponse<ApiResponseData<INotification> & { grouped_notifications: NotificationGroup }>) => {
                success(sanitized, apiResponse.secondary_data?.un_reads?.team_notifications);
            }).catch(BaseService.reportError).finally(done);
        }}
    />);

    function cancelTeamInvite(teamInviteId: string) {
        const dialog = ConfirmDialog({
            onLoading: async (alert: AlertInterface) => {
                teamService.cancelTeamInvite(teamInviteId).then(({}: SanitizedResponse<any>) => {
                    alert.destroy(() => {
                        Siren.alert(labels.invite_cancelled);
                    });
                }).catch((error: SanitizedResponse<any>) => {
                    alert.destroy(() => BaseService.reportError(error));
                });
                return false;
            },
        });
        dialog.show();
    }

}

export default TeamNotifications;
